import script from "./GrLayoutTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./GrLayoutTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./GrLayoutTemplate.vue?vue&type=style&index=0&id=c27fba50&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c27fba50"]])

export default __exports__